import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetUpgradeJobLink(jobId: string, campaign?: string) {
  const countryCode = useSiteCountryCode();

  return `/${countryCode}/jobs/${jobId}/upgrade-job${
    campaign ? `?campaign=${campaign}` : ''
  }`;
}
